import { useRouter } from 'next/router';
import useSWR from 'swr';
import fetch from '@api/fetchers';
import { useCallback } from 'react';
import { emptyList } from '@constants/empty';
import { readCookie } from '@utils/cookies';

export const getKey = (goalUID) =>
  goalUID
    ? `v1/feeds/${goalUID}/pre-subscription-home/?limit=4&offset=0`
    : null;

const getOptions = (blocks) => {
  return {
    requestType: 'POST',
    body: {
      blocks
    }
  };
};
const usePresubscribedSpecificBlock = (blocks) => {
  const {
    query: { goalUID }
  } = useRouter();
  const accessToken = readCookie('accessToken') || null;

  const key = blocks.length > 0 ? getKey(accessToken ? null : goalUID) : null;
  const options = getOptions(blocks);
  const fetcher = useCallback(
    () =>
      fetch(key, options).then((data) => {
        if (data?.error) throw data.error;
        return data;
      }),
    [key, options]
  );

  const { data, error, ...rest } = useSWR(key, fetcher);
  const results = data?.results || emptyList;
  return {
    specificSubscribedBlocks: results,
    revalidateSpecificSubscribedBlocks: rest.mutate
  };
};

export default usePresubscribedSpecificBlock;
